import { defineStore } from "pinia";
import { ref } from "vue";

/** Сайты партнёров, на которых перед расчётом нужно пройти капчу */
const CAPTCHA_HOSTS = ["ispace.kz"];

function isCaptchaHost(hostname: string): boolean {
    return CAPTCHA_HOSTS.some((host) => hostname === host || hostname.endsWith(`.${host}`));
}

export const useCaptchaStore = defineStore("captcha", () => {
    const isRequired = isCaptchaHost(window.location.hostname);

    /** Капча пройдена или не нужна на этом сайте */
    const isPassed = ref(!isRequired);

    return { isRequired, isPassed };
});
